export const demoOwnerStats = {
  listings: [
    {
      id: 1,
      name: "Mangalore Harbour Fish House",
      slug: "mangalore-harbour-fish-house",
      status: "active",
      views: 4820,
      rating: 4.7,
      reviews: 612,
      leads: 34,
      unreadLeads: 5,
      approvedReviews: 58,
    },
    {
      id: 2,
      name: "Harbour Seafood Cloud Kitchen",
      slug: "harbour-seafood-cloud-kitchen",
      status: "pending",
      views: 1240,
      rating: 0,
      reviews: 0,
      leads: 12,
      unreadLeads: 3,
      approvedReviews: 0,
    },
    {
      id: 3,
      name: "Coastal Spice Trading",
      slug: "coastal-spice-trading",
      status: "rejected",
      views: 305,
      rating: 0,
      reviews: 0,
      leads: 4,
      unreadLeads: 1,
      approvedReviews: 0,
    },
    {
      id: 4,
      name: "Udupi Royal Grand Banquet",
      slug: "udupi-royal-grand-banquet",
      status: "active",
      views: 3120,
      rating: 4.6,
      reviews: 143,
      leads: 21,
      unreadLeads: 2,
      approvedReviews: 19,
    },
    {
      id: 5,
      name: "Sunrise Ayurveda Wellness Retreat",
      slug: "sunrise-ayurveda-wellness-retreat",
      status: "active",
      views: 1980,
      rating: 4.8,
      reviews: 96,
      leads: 8,
      unreadLeads: 1,
      approvedReviews: 11,
    },
  ],
  totals: {
    views: 11465,
    leads: 79,
    reviews: 851,
  },
};